import { useState } from 'react';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import { StylishNewSearchBar } from 'components/DesignSystems/New/StylishNewSearchBar';
import { SharedIcon } from 'components/SharedIcon/SharedIcon';
import { CreateFeatureForm } from './CreateFeatureForm';
import { InternalLayer } from 'hooks/internalLayer/types';
import { CreateIcsIncidentLocationBody } from 'hooks/icsLocation/icsIncidentLocation.types';

type LayerFeaturesEditorProps = {
  internalLayer?: InternalLayer | null;
  showAddObjectButton?: boolean;
  showSearch?: boolean;
  searchTerm?: string;
  onChangeSearchTerm?: (term: string) => void;
  onSubmitLocation: ({
    location,
    pendingGraphicId,
  }: {
    location: CreateIcsIncidentLocationBody;
    pendingGraphicId?: string;
  }) => Promise<void> | void;
  onCancelLocation?: () => void;
};

export function LayerFeaturesEditor({
  internalLayer,
  showAddObjectButton,
  showSearch = true,
  searchTerm,
  onChangeSearchTerm,
  onSubmitLocation,
  onCancelLocation,
}: LayerFeaturesEditorProps) {
  const [isFormOpen, setIsFormOpen] = useState(false);

  return (
    <div className="layer-objects-editor">
      <div className="d-flex align-items-end mb-2 gap-2">
        {showSearch && (
          <div className="flex-grow-1">
            <StylishNewSearchBar
              label="Objects"
              placeholder="Search..."
              value={searchTerm ?? ''}
              onChangeSearchTerm={onChangeSearchTerm ?? (() => {})}
            />
          </div>
        )}
        {showAddObjectButton && (
          <StylishNewButton
            className="button--secondary"
            onClick={() => setIsFormOpen(!isFormOpen)}
          >
            <SharedIcon iconName="add" size="sm" />
            Add Object
          </StylishNewButton>
        )}
      </div>

      {isFormOpen && (
        <CreateFeatureForm
          internalLayer={internalLayer}
          onSubmit={onSubmitLocation}
          onClose={() => setIsFormOpen(false)}
          onDiscard={onCancelLocation}
        />
      )}
    </div>
  );
}
